import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const useLink = () => {
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()
    const { state } = useLocation()

    const handleLink = async () => {
        if (email !== '') {
            const emailInput = document.getElementById('email');
            if (emailInput.validity.valid) {
                setErrorMessage('')
                setIsLoading(true)
                try {
                    const response = await axios.post('/api/forgot_password', {
                        email
                    });
            
                    setSuccess(true);
                    setErrorMessage('');
                    setIsLoading(false)
                } catch (error) {
                    // Registration failed
                    if (error.response && error.response.data && error.response.data.message) {
                        setErrorMessage(error.response.data.message);
                    } else {
                        setErrorMessage('Der opstod en fejl');
                    }
                    setIsLoading(false)
                }
            } else {
                setErrorMessage('Ugyldig email')
            }
        } else {
          setErrorMessage('Indtast venligst din email')
        }
    }

    useEffect(() => {
      if (errorMessage !== '') {
        setErrorMessage('')
      }
    }, [email])

    return {
        email,
        setEmail,
        handleLink,
        errorMessage,
        success,
        isLoading
    };
}

export default useLink